const APPROVE_UPLOAD_IMAGE_FILE_TYPE = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/svg+xml'
]

export default {
  APPROVE_UPLOAD_IMAGE_FILE_TYPE
}
